module.exports = __webpack_public_path__ + "img/richmenu13.1d57e04e.png";